module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1204.481162f0.png";